module.exports = __webpack_public_path__ + "img/Camera.66a15736.svg";